module.exports = __webpack_public_path__ + "static/img/玩转产品智能化发展进阶攻略_详情_05.26cbd00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/img/about_article/初创企业成长计划_详情/玩转产品智能化发展进阶攻略_详情_05.png
// module id = 644
// module chunks = 1